/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Shared money/date formatting for the FinOps section. This service is
// USD-only in Phase 1 and every amount is micro-USD (1 USD = 1_000_000).

export const formatMicroUSD = (microUSD: number): string => {
  // Place the minus sign before the currency symbol (-$5.00, not $-5.00) so
  // negative amounts - a savings delta can be negative when the Podstack
  // equivalent costs more than the AWS resource (a keep_aws recommendation) -
  // render as valid currency.
  const usd = microUSD / 1_000_000;
  const sign = usd < 0 ? '-' : '';
  return `${sign}$${Math.abs(usd).toFixed(2)}`;
};

/**
 * Tailwind text-color class for a savings/delta amount: green when it's a real
 * saving (positive), red when negative (migrating would cost more), muted grey
 * when zero. Used so a keep_aws recommendation's negative "savings" isn't shown
 * in misleading green.
 */
export const savingsColorClass = (microUSD: number): string => {
  if (microUSD > 0) return 'text-green-400';
  if (microUSD < 0) return 'text-red-400';
  return 'text-gray-400';
};

export const formatDate = (iso?: string | null): string => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '-';
  }
};

/** Common AWS regions offered in the Connect form's region multiselect. */
export const COMMON_AWS_REGIONS: string[] = [
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
  'eu-west-1',
  'eu-central-1',
  'ap-south-1',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-northeast-1',
];
